// extracted by mini-css-extract-plugin
export default {"wrapper":"ThankYou_wrapper__m7CdJ","icon":"ThankYou_icon__Ifq0u","exit":"ThankYou_exit__AT3q3"};